import HeaderValue from "./headerValue";
import { IMachineOverview } from "./types";
import { formatDateTimeWithSeconds } from "../../../system/utils";

interface IProps {
  overviewData?: IMachineOverview;
}

const Header = ({ overviewData }: IProps) => {

  return (
    <div className="display-grid gap-1 m-1" style={{ gridTemplateColumns: "1fr 1fr", gridTemplateRows: "1fr 1fr" }}>
      <HeaderValue title="Heat Number" value={overviewData?.heatNumber ?? "---"} color="cyan" />
      <HeaderValue title="Steel" value={overviewData?.steelGrade ?? "---"} color="cyan" />
      <HeaderValue title="Begin" value={overviewData?.beginDatetime ? formatDateTimeWithSeconds(overviewData?.beginDatetime) : "---"} color="cyan" />
      <HeaderValue title="End" value={overviewData?.endDatetime ? formatDateTimeWithSeconds(overviewData?.endDatetime) : "---"} color="cyan" />
    </div>
  );
};

export default Header;